import React from "react";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import AnimatedRoutes from "./components/AnimatedRoutes";
import CookieConsent from "./CookieConsent";

function App() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        {/* Cookie Banner */}
        <CookieConsent />
        <AnimatedRoutes />
      </Layout>
    </>
  );
}

export default App;
